import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  apiUrls,
  billingBlockedStatuses,
  dataStorageKeywords,
  routeURL,
  userRoles,
} from 'src/utils/properties.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';
import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';

interface ProtectedRouteProps {
  element: JSX.Element;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ element }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAccess = async () => {
      const isLoggedIn = await getEncryptedLocalStorageData(
        dataStorageKeywords.IS_LOGGED_IN
      );
      if (!isLoggedIn) {
        navigate(routeURL.LOGIN);
        return;
      }
      const highestRole = await getEncryptedLocalStorageData(
        dataStorageKeywords.HIGHEST_ROLE
      );
      if (highestRole !== userRoles.OWNER && highestRole !== userRoles.ADMIN) {
        navigate(routeURL.UNAUTHORIZED_404);
        return;
      }

      try {
        const { data } = await axiosTokenInstance.get(
          apiUrls.SUBSCRIPTION_STATUS
        );
        const status = data?.data?.status;
        const settingsPath = routeURL.USER + routeURL.SETTINGS;

        if (
          billingBlockedStatuses.includes(status) &&
          location.pathname !== settingsPath
        ) {
          navigate(settingsPath, {
            replace: true,
            state: { billingRequired: true, subscriptionStatus: status },
          });
        }
      } catch {
        // Let protected page API calls surface backend subscription errors.
      }
    };

    checkAccess();
  }, [location.pathname, navigate]);

  return element;
};
